"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();

import React from "react"
import Link from "next/link"
import { DropdownMenuItem } from "@/components/ui/dropdown-menu"
import {
  ZESTLIFE_BLUE,
  ZESTLIFE_BLUE_BORDER,
  ZESTLIFE_DOT_EMPTY,
  ZESTLIFE_ONBOARDING_SUB,
} from "../zestlifeDropdownTokens"
import {
  SOFT_LIME_YELLOW,
  ZEST_BLACK,
} from "../../../../../lib/constants/brandColors"

export default function ProviderSetupCard({
  setupStepsRemaining,
  setupTotalSteps,
}: {
  setupStepsRemaining: number
  /** 4 for provider onboarding, 5 for org listing (leader dashboard parity). */
  setupTotalSteps: number
}) {
  if (setupStepsRemaining <= 0) {
    return null
  }

  const doneCount = Math.max(
    0,
    Math.min(setupTotalSteps, setupTotalSteps - setupStepsRemaining),
  )

  const stepLabel =
    setupStepsRemaining === 1
      ? "1 step remaining"
      : `${setupStepsRemaining} steps remaining`

  return (
    <div className="px-2 py-1">
      {/*
        A menu item so the dropdown auto-closes on selection (the old MUI
        version closed via onNavigate). Card colors: bg #E6F7FC
        (ZESTLIFE_BLUE_SOFT_BG), hover #d3effb (ZESTLIFE_ONBOARDING_HOVER_BG).
      */}
      <DropdownMenuItem asChild className="p-0">
        <Link
          href="/onboarding"
          className="flex cursor-pointer items-center gap-[9px] rounded-[10px] border-[0.5px] border-solid bg-[#E6F7FC] px-[11px] py-[9px] text-inherit no-underline transition-colors duration-[130ms] ease-in focus:bg-[#d3effb] data-highlighted:bg-[#d3effb]"
          style={{ borderColor: ZESTLIFE_BLUE_BORDER }}
        >
          <div className="min-w-0 flex-1">
            <div
              className="w-fit max-w-full rounded-[6px] px-[6px] py-1"
              style={{ backgroundColor: SOFT_LIME_YELLOW }}
            >
              <p
                className="m-0 text-[12px] font-medium leading-[1.25]"
                style={{ color: ZEST_BLACK }}
              >
                {stepLabel}
              </p>
            </div>
            <p
              className="m-0 mt-0.5 text-[11px] leading-[1.25]"
              style={{ color: ZESTLIFE_ONBOARDING_SUB }}
            >
              Complete your setup
            </p>
            <div className="mt-[5px] flex gap-[3px]">
              {Array.from({ length: setupTotalSteps }, (_, i) => (
                <span
                  key={i}
                  className="h-[5px] w-[5px] rounded-full"
                  style={{
                    backgroundColor:
                      i < doneCount ? ZESTLIFE_BLUE : ZESTLIFE_DOT_EMPTY,
                  }}
                />
              ))}
            </div>
          </div>
          <span className="shrink-0 text-[13px]" style={{ color: ZESTLIFE_BLUE }}>
            →
          </span>
        </Link>
      </DropdownMenuItem>
    </div>
  )
}
